<script setup lang="ts">
const { t, te } = useI18n();

const props = defineProps({
  filterValue: {
    type: String,
    required: true,
  },
  propertyValue: {
    type: String,
    required: true,
  },
});

const handlePropertyValueKey = () => {
  const filterType = props.propertyValue.split(".")[0];
  const merchantId = appStateStore.currentMerchant;
  const key = props.propertyValue.split(".").pop();
  if (filterType === "rarity")
    return t(`main.property.rarity.${props.filterValue}`);
  if (te(`${merchantId}.property.${key}.values.${props.filterValue}`))
    return t(`${merchantId}.property.${key}.values.${props.filterValue}`);
  return props.filterValue;
};

const appStateStore = useAppStateStore();
const isChecked = defineModel();
</script>

<template>
  <div class="w-full flex items-center gap-2 cursor-pointer">
    <div class="relative flex items-center" @click="isChecked = !isChecked">
      <input
        :id="filterValue"
        v-model="isChecked"
        :name="filterValue"
        type="checkbox"
        class="appearance-none w-4" />
      <NuxtIcon
        v-if="isChecked"
        name="mdi:checkbox-outline"
        alt="checkbox"
        class="absolute w-5 h-5 text-neutral-300" />
      <NuxtIcon
        v-else
        name="mdi:checkbox-blank-outline"
        alt="checkbox"
        class="absolute w-5 h-5 text-neutral-300" />
    </div>
    <label :for="filterValue" class="w-full text-neutral-300 cursor-pointer">
      {{ handlePropertyValueKey() }}
    </label>
  </div>
</template>
